export const ACTION_TYPE = 'ADD_COMPLAINT_HISTORY';
export const ACTION_VERSION = 1;

export function createComplaintAction(payload, actorUid, operationId, now = Date.now()) {
  const clean = {
    patient_mongo_id: payload.patient_mongo_id || '', patient_id: payload.patient_id || '',
    doctor_id: payload.doctor_id || '', complaint: (payload.complaint || '').trim(),
    diagnosis: (payload.diagnosis || '').trim(), procedure: (payload.procedure || '').trim(),
  };
  if (!actorUid || !/^[0-9a-f]{24}$/i.test(clean.patient_mongo_id) || !clean.patient_id || !clean.doctor_id ||
      !(clean.complaint || clean.diagnosis || clean.procedure) ||
      [clean.complaint, clean.diagnosis, clean.procedure].some(value => value.length > 10000)) {
    throw new Error('A stable patient file and clinical text are required for offline saving.');
  }
  return {
    operationId, actorUid, type: ACTION_TYPE, schemaVersion: ACTION_VERSION,
    createdAt: now, occurredAt: new Date(now).toISOString(), payload: clean,
    status: 'pending', attempts: 0, nextAttemptAt: 0, lastErrorCode: '',
    leaseOwner: '', leaseUntil: 0,
  };
}

export function actionRequest(action) {
  if (action.type !== ACTION_TYPE || action.schemaVersion !== ACTION_VERSION) {
    throw Object.assign(new Error('This action requires a compatible dashboard version.'), { code: 'UNSUPPORTED_ACTION_VERSION' });
  }
  return { ...action.payload, offline_schema_version: action.schemaVersion, offline_occurred_at: action.occurredAt };
}

export function failureState(error, attempts, now = Date.now(), random = Math.random()) {
  const status = error?.response?.status;
  const retryable = !status || status === 408 || status === 429 || status >= 500;
  const code = error?.response?.data?.code || error?.code || 'NETWORK_UNAVAILABLE';
  const terminal = ['UNSUPPORTED_ACTION_VERSION', 'ERR_VIEWER_ONLY', 'SESSION_CHANGED'].includes(code);
  return {
    status: retryable && !terminal ? 'retry' : 'attention',
    // Do not store arbitrary server messages: they might contain clinical data.
    lastErrorCode: String(code).slice(0, 80), attempts,
    nextAttemptAt: retryable && !terminal ? now + Math.min(300000, 2000 * 2 ** Math.min(attempts, 7)) + Math.floor(random * 2000) : 0,
    leaseOwner: '', leaseUntil: 0,
  };
}

export function replayCandidates(actions, actorUid, doctorId, now = Date.now()) {
  return actions.filter(action => action.actorUid === actorUid && action.payload?.doctor_id === doctorId &&
    action.cloudConfirmed && ['pending', 'retry'].includes(action.status) &&
    action.nextAttemptAt <= now && action.leaseUntil <= now)
    .sort((a, b) => a.createdAt - b.createdAt).slice(0, 10);
}
